export default __webpack_public_path__ + "static/media/avatar.efbacd3d.png";